import * as React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined'

type EmptyOrderBumpsProps = {
  /** Exiba somente quando NÃO houver order bumps */
  visible: boolean

  /** Chame a mesma ação do seu botão "+ Adicionar Order Bump" */
  onAddClick: () => void

  /** Opcional: desabilitar quando usuário não puder editar */
  disabled?: boolean

  /** Opcional: título custom */
  title?: string

  /** Opcional: descrição custom */
  description?: string

  /** Opcional: texto do botão */
  ctaText?: string
}

export function EmptyOrderBumps({
  visible,
  onAddClick,
  disabled = false,
  title = 'Nenhum Order Bump vinculado',
  description = 'Adicione um Order Bump para oferecer um item extra no checkout e aumentar o ticket médio.',
  ctaText = 'Adicionar Order Bump',
}: EmptyOrderBumpsProps) {
  if (!visible) return null

  return (
    <Box
      sx={{
        border: '1px dashed',
        borderColor: 'rgba(28, 82, 189, 0.25)',
        bgcolor: 'rgba(216, 217, 255, 0.35)',
        borderRadius: 2,
        p: 2,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 2,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(28, 82, 189, 0.10)',
            color: 'rgba(28, 82, 189, 1)',
            flexShrink: 0,
          }}
          aria-hidden
        >
          <LocalOfferOutlinedIcon fontSize="small" />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: 'Montserrat',
              fontWeight: 700,
              fontSize: 13,
              lineHeight: '18px',
              color: 'rgba(28, 82, 189, 1)',
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              mt: 0.25,
              fontFamily: 'Montserrat',
              fontWeight: 500,
              fontSize: 12,
              lineHeight: '16px',
              color: 'rgba(28, 82, 189, 0.85)',
            }}
          >
            {description}
          </Typography>

          <Button
            onClick={onAddClick}
            disabled={disabled}
            variant="outlined"
            size="small"
            startIcon={<AddIcon />}
            sx={{
              mt: 1.25,
              borderRadius: 2,
              textTransform: 'none',
              fontFamily: 'Montserrat',
              fontWeight: 700,
              borderColor: 'rgba(28, 82, 189, 0.35)',
              color: 'rgba(28, 82, 189, 1)',
              '&:hover': {
                borderColor: 'rgba(28, 82, 189, 0.6)',
                bgcolor: 'rgba(28, 82, 189, 0.06)',
              },
            }}
          >
            {ctaText}
          </Button>
        </Box>
      </Stack>
    </Box>
  )
}
